import { writable } from 'svelte/store';

export const language = writable("RU");

export const checkLang = writable(false)
